import { createContext, useContext } from "react";
import PropTypes from "prop-types";

const LocaleProviderContext = createContext();
LocaleProviderContext.displayName = "localeProvider";

export const useLocaleProvider = () => useContext(LocaleProviderContext);

const getLanguageStrings = (localeProvider) =>
  localeProvider?.languageStrings || localeProvider || {};

export const useTranslate = (localeProvider) => (string) =>
  getLanguageStrings(localeProvider)[string] ?? string;

export const LocaleProvider = ({ children, languageStrings }) => (
  <LocaleProviderContext.Provider value={{ languageStrings }}>
    {children}
  </LocaleProviderContext.Provider>
);

LocaleProvider.propTypes = {
  children: PropTypes.node.isRequired,
  languageStrings: PropTypes.object,
};
